import { Component, OnInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Broker, Platform } from '@c4/core';

import { SysmanComponentBase, IOnBrokerConnectedInit } from '../sysman/sysman.component';
import { ConnectedDeviceService, OutputLogService, VersionsService } from '../services';

@Component({
  selector: 'sysman-output',
  templateUrl: './sysman-output.component.html',
  styleUrls: ['./sysman-output.component.less']
})
export class SysmanOutputComponent extends SysmanComponentBase implements OnInit {

  outputLog: any; // key/val map
  outputLogOptions: Array<{ name: string, value: string }>;
  selectedOutputLog: string;
  selectedOutputLogValue: string = "";
  showOptions: boolean = false;

  constructor(private store: Store<any>, private router: Router, private route: ActivatedRoute,
    private broker: Broker, private platform: Platform,
    private connectedDeviceService: ConnectedDeviceService,
    private outputLogService: OutputLogService,
    private versionsService: VersionsService) {
    super(router, route, store, broker, platform, connectedDeviceService, versionsService);
    super.setBrokerInit(this.onBrokerConnectedInit); // method to call on broker init
    this.selectedOutputLog = "";
    this.selectedOutputLogValue = "";
    this.outputLogService.outputLog.subscribe(sysmanlog => {
      if (sysmanlog) {
        this.outputLog = sysmanlog.outputlog;
        let options = [];
        Object.keys(sysmanlog.outputlog).forEach(key => {
          options.push({ name: key, value: key });
        });
        // sort options by name
        options = options.sort((a, b) => { if (a.name > b.name) return 1; if (b.name > a.name) return -1; return 0; });
        this.outputLogOptions = options;
        if (options.length > 0)
          this.selectedOutputLog = options[0].name;
        this.selectedOutputLogValue = this.outputLog[this.selectedOutputLog];
        this.connectedDeviceService.setWorking(false);
      }
    });
  }

  ngOnInit() {
    super.OnInit();
    this.selectedOutputLogValue = "";
    this.connectedDeviceService.setWorking(true);
  }

  ngOnDestroy() {
    super.destroy();
  }

  onBrokerConnectedInit() {
    this.connDevice.take(1).subscribe(conn => {
      let ip: string = "";
      if (this.brokerHost != conn.connectedDevice.address)
        ip = conn.connectedDevice.address;
      this.outputLogService.startOutputLog(ip);
    });
  }

  onChangeOutputLog() {
    this.selectedOutputLogValue = this.outputLog[this.selectedOutputLog];
  }

  logSelected(logvalue: string) {
    this.selectedOutputLog = logvalue;
    this.onChangeOutputLog();
  }
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-output/sysman-output.component.ts